"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles_utils = require("../styles/utils/styles_utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var center = _styles_utils.flexUtils.center;
exports["default"] = {
  container: _objectSpread({
    height: 'fit-content',
    width: 'fit-content',
    whiteSpace: 'nowrap',
    borderRadius: 100,
    margin: [10, 7.5],
    padding: [12, 22],
    color: '#fff',
    backgroundColor: 'currentColor'
  }, center),
  typography: {
    display: 'flex',
    alignItems: 'center'
  }
};